export default {
  'Cases types': 'TIPURI DE CUTII',
  'Possible contents of the case': 'Conținutul posibil al cutiei',
  'Other cases': 'ALTE CUTII',
  'Open for': 'Deschideți pentru',
};
